var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "#FFF5D1",
    fillOpacity: 0.46
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.071 36.285a3.432 3.432 0 0 1 3.429 3.429v10.285a3.432 3.432 0 0 1-3.429 3.429H30.93a3.43 3.43 0 0 1-3.429-3.429V39.714a3.43 3.43 0 0 1 3.429-3.429H48.07Zm-6.857 6.857c0-.948-.766-1.714-1.714-1.714s-1.714.766-1.714 1.714v3.429c0 .948.766 1.714 1.714 1.714s1.714-.766 1.714-1.714v-3.429Z",
    fill: "#FFD688"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.5 29.429a4.285 4.285 0 0 0-4.285 4.285v2.572h-3.429v-2.572a7.715 7.715 0 0 1 15.429 0v2.572h-3.429v-2.572A4.285 4.285 0 0 0 39.5 29.43Z",
    fill: "#C0C2DE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "lock_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(27.5 26)",
    d: "M0 0h24v27.429H0z"
  })))));
};
export default SvgLock;